import React, { useContext, useEffect } from 'react';
import { Radio, Button, Image } from 'antd';
import { KycContext } from '../../../context/KycContext';
import { DashboardContext } from '../../../context/DashboardContext';
import { AlertsContext } from '../../../context/AlertsContext';
import { Scrollbars } from 'react-custom-scrollbars';
import Alert from '../../alerts/WarningAlert';
import NoData from '../../no-data/NoData';
import Loader from '../../widgets/loader/ComponentLoader';
import warning_alerts from 'utils/messages/warning_alerts';
import { api_srv } from 'services';

export default function SelectClass() {
	const { next } = useContext(KycContext);
	const { showAlert, setShowAlert } = useContext(AlertsContext);
	const { handleClassChange, quotations, setQuotations } = useContext(DashboardContext);
	async function fetch_subclass() {
		setQuotations({ ...quotations, loading: true });
		try {
			let resp = await (await api_srv).get_subclass();
			setQuotations({ ...quotations, subclass: resp, loading: false });
		} catch (err) {
			let error = await err;
			setQuotations({ ...quotations, loading: false });
			// addToast(error.message, {
			//   appearance: "error",
			//   autoDismiss: true,
			// });
		}
	}
	useEffect(() => {
		fetch_subclass();
	}, []);

	const check = () => {
		quotations.insuranceClass === '' ? setShowAlert(true) : next();
	};

	return (
		<div>
			{showAlert && <Alert message={warning_alerts.select_insurance_class} variant="danger" />}
			{quotations.subclass.insurance_sub_classes === undefined && !quotations.loading ? (
				<NoData message="No subclasses" />
			) : quotations.subclass.insurance_sub_classes === undefined && quotations.loading ? (
				<Loader />
			) : (
				<>
					<h5 className="upload-title text-center mt-5">Select Insurance Class</h5>
					<Scrollbars autoHide autoHideTimeout={1000} autoHideDuration={200} style={{ height: 400 }}>
						<Radio.Group
							className="mt-5 "
							style={{ overflowX: 'hidden' }}
							value={quotations.insuranceClass}
							onChange={handleClassChange}
						>
							<div className="row">
								{quotations.subclass.insurance_sub_classes.map((subclass) => {
									return (
										<div className="col-md-3">
											<Radio
												className=" wd-170 custom_radio"
												name="radio"
												value={subclass.code}
												rel="tooltip"
											>
												<div className="card rounded-10 mb-3">
													<div className="card-body   ">
														<div className="d-flex align-items-center justify-content-center">
															{' '}
															<Image
																width="3.5em"
																height="3.5em"
																src={`https://intermediary-uat.nexus.ke/api ${subclass.icon}`}
																fallback="data:image/png;base64,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"
															/>
															{/* <img 
                              src={`https://intermediary-uat.nexus.ke/api" + ${subclass.icon}`}
                               alt="" 
                               onError={(e)=>{ if (e.target.src !== "image_path_here"){
                                e.target.src="image_path_here";}
                              }
                        } style={{ height: "3.5em", width: "3.5em" }} /> */}
														</div>
													</div>
													<p className="text-center text-wrap">{subclass.name}</p>
												</div>
											</Radio>
										</div>
									);
								})}
							</div>
						</Radio.Group>
					</Scrollbars>
				</>
			)}
			<footer>
				<Button
					disabled={quotations.loading}
					className="btn-blue float-right mt-5 mb-3 text-white px-4 py-1 rounded "
					type="submit"
					onClick={() => check()}
				>
					Next
				</Button>
			</footer>
		</div>
	);
}
